<template>
  <div class="row">
    <div
      class="col-md-12"
      v-for="x of data"
      v-bind:key="x.value"
      @change="onChange($event,x.value)"
    >
      <b-form-checkbox :checked="item.indexOf(x.value) >= 0">{{x.text}}</b-form-checkbox>
    </div>
  </div>
</template>

<script>
import httpHelper from "../helpers/httpHelper";
import sessionHelper from "../helpers/sessionHelper";

export default {
  name: "MDMulty",
  props: ["group", "value"],
  data: function() {
    return {
      data: [],
      item: null
    };
  },
  watch: {
    value: function(newVal, oldVal) {
      this.item = this.value;
      console.log(this.item);
    }
  },
  mounted() {
    httpHelper.getData("metadata?metadata_group_id=" + this.group).then(res => {
      this.data = res.result.map(element => {
        return {
          value: element.id,
          text: element.title
        };
      });
    });
    if (this.item == null) {
      this.item = [];
    }
  },
  methods: {
    onChange(event, value) {
      if (event.target.checked) {
        this.item.push(value);
      } else {
        this.item.splice(this.item.indexOf(value), 1);
      }
      this.$emit("input", this.item);
    }
  }
};
</script>